import { useWebhookCreateIntegrationWebhookCreatePostMutation } from '@shared/api';
import type { WebhookIntegrationCreateFormValues } from '../lib/types';

export const useCreateIntegration = () => {
  const [createIntegrationMutation, { isLoading: isCreateIntegrationLoading }] =
    useWebhookCreateIntegrationWebhookCreatePostMutation();

  const createIntegration = async (
    channelId: number,
    values: WebhookIntegrationCreateFormValues,
  ) => {
    try {
      return await createIntegrationMutation({
        webhookIntegrationCreate: {
          channel_id: channelId,
          title: values.title,
          callback_url: values.callbackUrl,
          method: values.method,
        },
      }).unwrap();
    } catch {
      return null;
    }
  };

  return {
    createIntegration,
    isCreateIntegrationLoading,
  };
};
